import React from 'react'
import PropTypes from 'prop-types'

const Warning = ({ size = 20 }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.007 7.01564V8.01564V9.01564M10.007 13.0156V13.0256V13.0156Z"
                fill="#FFC20D"
            />
            <path
                d="M3.00703 17.0156H17.007C17.3333 17.0134 17.6541 16.9313 17.9414 16.7765C18.2287 16.6218 18.4738 16.3991 18.6552 16.1279C18.8367 15.8567 18.949 15.5452 18.9825 15.2206C19.0159 14.896 18.9694 14.5681 18.847 14.2656L11.747 2.01564C11.5741 1.70304 11.3205 1.44247 11.0128 1.26103C10.705 1.07958 10.3543 0.983887 9.99703 0.983887C9.63977 0.983887 9.28903 1.07958 8.98127 1.26103C8.67352 1.44247 8.41998 1.70304 8.24703 2.01564L1.14703 14.2656C1.02697 14.5612 0.979359 14.8812 1.00818 15.1989C1.03699 15.5167 1.1414 15.8229 1.31268 16.092C1.48396 16.3612 1.71714 16.5855 1.99275 16.7461C2.26837 16.9068 2.57842 16.9992 2.89703 17.0156"
                fill="#FFC20D"
            />
            <path
                d="M10.007 7.01564V8.01564V9.01564V10.4995M10.007 13.0156V13.0256M3.00703 17.0156H17.007C17.3333 17.0134 17.6541 16.9313 17.9414 16.7765C18.2287 16.6218 18.4738 16.3991 18.6552 16.1279C18.8367 15.8567 18.949 15.5452 18.9825 15.2206C19.0159 14.896 18.9694 14.5681 18.847 14.2656L11.747 2.01564C11.5741 1.70304 11.3205 1.44247 11.0128 1.26103C10.705 1.07958 10.3543 0.983887 9.99703 0.983887C9.63977 0.983887 9.28903 1.07958 8.98127 1.26103C8.67352 1.44247 8.41998 1.70304 8.24703 2.01564L1.14703 14.2656C1.02697 14.5612 0.979359 14.8812 1.00818 15.1989C1.03699 15.5167 1.1414 15.8229 1.31268 16.092C1.48396 16.3612 1.71714 16.5855 1.99275 16.7461C2.26837 16.9068 2.57842 16.9992 2.89703 17.0156"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

Warning.propTypes = {
    size: PropTypes.number,
}

export default Warning
